 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
          Policy
      <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <form data-vv-scope="queryPolicyFilterForm">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div>
                      <v-icon>mdi-filter-variant</v-icon> Filters
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs12>
                            <v-text-field v-model="filtersPolicy.polNo" :label="filtersPolicyLabel.polNo" :error-messages="errors.collect('filtersPolicy.polNo')" data-vv-name="filtersPolicy.polNo" :data-vv-as="filtersPolicyLabel.polNo" v-validate="'entry|max:20'"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearPolicyFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="doPolicyFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
            </v-flex>
            <v-flex xs12 class="mt-2">
              <!-- <v-data-table :headers="polHeaders" :items="polItems" v-bind:options.sync="paginationPolicy" :footer-props="{'items-per-page-options': itemsPerPage }" :server-items-length="totalItemsPol" :loading="loading" class="elevation-1" :no-data-text="noDataText">
                <template v-slot:item="row">
                  <td>{{ row.item.polNo}}</td>
                  <td>{{ row.item.renCnt}}</td>
                  <td>{{ row.item.endtCnt}}</td>
                  <td>{{ row.item.insdName1}}</td>
                  <td>{{ formatDate(row.item.comDate)}}</td>
                  <td>{{ formatDate(row.item.expDate)}}</td>
                  <td style="text-align:center">
                    <v-btn icon v-on="on" color="primary" text type="submit" @click.prevent="assignPolicy(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table> -->
              <v-data-table
              :headers="polHeaders"
              :items="polItems"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :loading="loading"
              :server-items-length="totalItemsPol"
              v-bind:options.sync="paginationPolicy"
              >
                <template v-slot:item="row">
                  <tr>
                    <td>{{ row.item.polNo}}</td>
                    <td>{{ row.item.renCnt}}</td>
                    <td>{{ row.item.endtCnt}}</td>
                    <td>{{ row.item.insdName1}}</td>
                    <td>{{ formatDate(row.item.comDate)}}</td>
                    <td>{{ formatDate(row.item.expDate)}}</td>
                    <td style="text-align:center">
                      <v-btn icon color="primary" text type="submit" @click.prevent="assignPolicy(row.item)">
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
        </v-card-text>
      </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      actionName: '',
      filtersPolicyLabel: {
        polNo: 'Policy'
      },
      filtersPolicy: {
        polNo: undefined
      },
      polItems: [],
      totalItemsPol: 0,
      polHeaders: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Renewal Count', align: 'left', value: 'renCnt' },
        { text: 'Endorsement Count', align: 'left', value: 'endtCnt' },
        { text: 'Insured Name', align: 'left', value: 'insdName1' },
        { text: 'Commencement Date', align: 'left', value: 'comDate' },
        { text: 'Expiry Date', align: 'left', value: 'expDate' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPolicy: {}
    }
  },
  mounted() {
    this.doClearPolicyFilters()
  },
  methods: {
    closeDialog() {
      this.filtersPolicy.polNo = ''
      this.$emit('close')
    },
    doClearPolicyFilters() {
      this.filtersPolicy.polNo = ''
      this.fetchPolicyData()
    },
    doPolicyFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryPolicyFilterForm').then(result => {
        if (result) {
          this.paginationPolicy.page = 1
          this.fetchPolicyData()
        }
      })
    },
    async fetchPolicyData() {
      const apiUrl = this.apiURI
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationPolicy
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let messageFilters = clone(this.filtersPolicy)
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), messageFilters, this.paginationPolicy.sortBy, this.paginationPolicy.sortDesc))
          if (result.data) {
            this.totalItemsPol = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'polItems', data)
            } else {
              this.$set(this, 'polItems', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignPolicy(data) {
      this.$emit('assignPolicyInfo', data)
      this.$emit('close')
    }
  },
  watch: {
    'paginationPolicy': function (value) {
      this.fetchPolicyData()
    }
  },
  computed: {
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ],
  props: {
    'apiURI': String
  }
}
</script>
